import Swiper, { Lazy, Navigation, Pagination } from 'swiper';

export default class ExpendableArticle {

  constructor() {
    this.init();
  }

  init() {

    if(document.querySelectorAll('.article-images')) {
			Swiper.use([Navigation, Pagination, Lazy]);
			new Swiper('.article-images', {
        slidesPerView: 1,
				slidesPerColumn: 1,
				slidesPerGroup: 1,
				preloadImages: false,
				pagination: {
				  el: '.article-images .swiper-pagination',
				  clickable: true
				},
				navigation: {
				  nextEl: '.article-images-next',
				  prevEl: '.article-images-prev'
				},
				lazy: {
					loadPrevNext: false,
					loadOnTransitionStart: true,
				},
				on: {
				  init: function () {
				  }
				}
			});
    }

    // let readMoreButtons = document.querySelectorAll(".read-more");
    // let readMoreButtonContainers = document.querySelectorAll(".read-more-container");
    // let articleBody = document.querySelectorAll(".article-body");
    // let articleContainers = document.querySelectorAll(".article-container");
    // let articleMoreContainers = document.querySelectorAll(".article-more");
    // let articleImagesContainers = document.querySelectorAll(".article-images-container");

    // articleMoreContainers.forEach((container) => {
    //   container.classList.add('hidden');
    // });

    // articleBody.forEach((body) => {
    //   body.style.display = "none";
    // });

    // window.addEventListener("load", () => {
    //   for (let i = 0; i < articleImagesContainers.length; i++) {
    //       let height = articleContainers[i].getBoundingClientRect().height;
    //       articleImagesContainers[i].style.maxHeight = height + 'px';
    //   }
    // });

    // window.addEventListener("resize", () => {
    //   for (let i = 0; i < articleImagesContainers.length; i++) {
    //       let height = articleContainers[i].getBoundingClientRect().height;
    //       articleImagesContainers[i].style.maxHeight = height + 'px';
    //   }
    // });

    // for (let i = 0; i < readMoreButtons.length; i++) {
    //   readMoreButtons.forEach((button, i) => {
    //     button.addEventListener('click', () => {
    //       readMoreButtonContainers[i].style.display = "none";
    //       articleBody[i].style.display = "block";

    //       if(articleMoreContainers[i]) {
    //         articleMoreContainers[i].classList.add('lg:block');
    //       }
    //     });
    //   });
    // }
  }
}
